import MemberEligibilityBadges from './MemberEligibilityBadges';

export default MemberEligibilityBadges;
